export const SET_ACTIVE_CREDIT_TYPE = 'SET_ACTIVE_CREDIT_TYPE'

export const activeCreditType = activePromo => ({
	type: SET_ACTIVE_CREDIT_TYPE,
	payload: activePromo
})

export default function setActiveCreditType(activeType) {
	return dispatch => {
		dispatch(activeCreditType(activeType))
	}
}


// WEBPACK FOOTER //
// ./src/actions/activeCreditTypeActions.js